export const globalService = {
  getObjectById(object, id) {
    let cloned_object = JSON.parse(JSON.stringify(object));

    for (let i = 0; i < cloned_object.length; i++) {
        if(cloned_object[i].id == id){
            return cloned_object[i];
        }
    }

    return false;
  },
};